import RestaurantListPage from '@components/offer/pages/RestaurantListPage';
import React from 'react';
import Landing from '../components/Landing';

interface LandingPageProps {
}

const LandingPage: React.FC<LandingPageProps> = ({ }) => {
    return (
        <>
            <Landing />
            <RestaurantListPage />
        </>
    )
}

export default LandingPage;